// Shared scanned-RO page handling for My Compliance and the claim portals.

// A page's own text is trusted only when it is a real RO page (enough text plus an RO number or VIN);
// scanned ROs sometimes carry a small pasted text box (e.g. a GM bulletin) over the scan.
export const isRoText = (t) => t.replace(/\s/g, "").length >= 200 && (/\b\d{6,8}\s*\/\s*\d{1,2}\b/.test(t) || /\b[A-HJ-NPR-Z0-9]{17}\b/.test(t));

const roOf = (t) => (t.match(/(\d{8})\s*\/\s*\d{1,2}\b/) || t.match(/\b(\d{6,8})\s*\/\s*\d{1,2}\b/) || [])[1];
const pageOf = (t) => Number((t.match(/\b\d{6,8}\s*\/\s*(\d{1,2})\b/) || [])[1] || 0);
const vinOf = (t) => (t.match(/\b[A-HJ-NPR-Z0-9]{17}\b/) || [])[0];
// Same vehicle and an RO number that differs by one misread digit ("62399811" vs "62339811") is the same RO.
const nearSame = (a, b) => a && b && a.length === b.length && [...a].filter((c, i) => c !== b[i]).length <= 1;
// OCR misreads VINs: up to 3 differing characters is still the same vehicle.
const sameVin = (a, b) => a && b && [...a].filter((c, i) => c !== b[i]).length <= 3;
// A page with its own RO header for a different vehicle always starts a new RO.
const newHeader = (t, vin, last) => vin && /R\/O Number/i.test(t)
  && ((last.vin && !sameVin(vin, last.vin)) || (!last.vin && /(^|\n)\s*#\s*1\b/.test(t)));

// Group page texts into ROs: a new RO starts when a page shows a different RO number, or a new RO header with a different VIN.
// Pages of one RO are put back in page order (scanners often feed /4, /3, /2, /1).
export function groupRoPages(pages) {
  const groups = [];
  pages.forEach((t) => {
    if (!t || !t.trim()) return;
    const ro = roOf(t), vin = vinOf(t);
    const last = groups[groups.length - 1];
    const same = last && (ro
      ? ro === last.ro || (!last.ro && !newHeader(t, vin, last)) || (sameVin(vin, last.vin) && nearSame(ro, last.ro))
      : !newHeader(t, vin, last));
    if (same) { last.pages.push(t); last.ro = last.ro || ro; last.vin = last.vin || vin; }
    else groups.push({ ro, vin, pages: [t] });
  });
  return groups.map((g) => ({ ro: g.ro, text: [...g.pages].sort((a, b) => pageOf(a) - pageOf(b)).join("\n") }));
}
